const NAME = "ACCESS_SETTINGS_PAGE";

export default NAME;
